<template>
  <div>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="editApplicationStatus">
      <i class="material-icons-outlined align-middle">edit</i>
    </a>
    <a class="ag-nomal-action-menu" href="javascript:void(0);" @click="deleteApplicationStatus">
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
export default {
  methods: {
    deleteApplicationStatus: function() {
      this.params.context.componentParent.deleteApplicationStatus(this.params.data);
    },
    editApplicationStatus: function() {
      this.params.context.componentParent.editApplicationStatus(this.params.data);
    }
  }
};
</script>
